/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { Flex } from '../UNSAFE_Flex';
import { Skeleton } from '../UNSAFE_Skeleton';
import { SkeletonContainer } from './SkeletonContainer';

export const GroupLoadingIndicator = () => (
  <SkeletonContainer minimumCount={3}>
    {(index: number) => {
      const padding = { paddingLeft: index * 10 + 'px' };
      return (
        <Flex height="12x" align="center">
          <span style={padding}></span>
          <Skeleton height="4x" />
        </Flex>
      );
    }}
  </SkeletonContainer>
);
